import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectCompact } from 'app/pages/Home/slice/selectors';
import { MonthlyGridBackground } from './MonthlyGridBackground';
import type { DayColumnDescriptor, MonthDescriptor } from '../utils/types';
import styles from '../MonthlyRoadmap.module.scss';

interface MonthlyTimelineMonthsBodyProps {
  months: MonthDescriptor[];
  dayColumns: DayColumnDescriptor[];
  expandedMonths: string[];
  bodyWidthPx: number;
  columnsWidthPx: number;
  children: React.ReactNode;
}

export const MonthlyTimelineMonthsBody = memo(
  ({
    months,
    dayColumns,
    expandedMonths,
    bodyWidthPx,
    columnsWidthPx,
    children
  }: MonthlyTimelineMonthsBodyProps) => {
    const isCompact = useSelector(selectCompact);
    const bodyExtensionPx = Math.max(0, bodyWidthPx - columnsWidthPx);

    return (
      <div
        data-testid="monthly-row-months-body"
        className={styles.monthlySwimlaneRowBody}
        style={{ minWidth: `${bodyWidthPx}px` }}
      >
        <MonthlyGridBackground
          months={months}
          dayColumns={dayColumns}
          expandedMonths={expandedMonths}
          isCompact={isCompact}
        />
        {bodyExtensionPx > 0 && (
          <div
            data-testid="monthly-row-body-extension"
            className={styles.monthlyRowBodyExtensionOverlay}
            style={{
              left: `${columnsWidthPx}px`,
              width: `${bodyExtensionPx}px`
            }}
          />
        )}
        {children}
      </div>
    );
  }
);
